import React, { useEffect, useState } from "react";
import { sanityClient, urlFor } from "../client";
import { useParams } from "react-router-dom";
import { BiArrowBack, BiBed, BiBath, BiFile, BiMap, BiMapAlt, BiMoney, BiPhoneCall, BiMailSend, BiMessageAdd, BiLandscape } from "react-icons/bi";
// import { Form } from "../components/contact";
import { PortableText } from '@portabletext/react';

const handleGoBack = () => {
  window.history.back();
};

const SinglePost = () => {
  const [singlePost, setSinglePost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "properties" && slug.current == $slug]{
          _id,
          propertyName,
          slug,
          propertyType,
          location,
          description1,
          services1,
          price1,
          description2,
          special_condition_status,
          price2,
          category,
          address,
          city,
          bedrooms,
          bathrooms,
          price,
          description,
          images,
          plotSize,
          status,
          createdAt
        }`,
        { slug }
      )
      .then((data) => {
        if (data.length > 0) {
          setSinglePost(data[0]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Sanity fetch error:", error);
        setLoading(false);
      });
  }, [slug]);

  return (
    <div className="pt-16 max-w-7xl mx-auto px-4">
      {previewImage && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black/70 flex items-center justify-center z-50"
          onClick={() => setPreviewImage(null)}
        >
          <img
            src={previewImage}
            alt="Preview"
            className="w-[90%] h-auto max-w-5xl object-contain rounded-xl shadow-xl"
            // className="max-w-full max-h-full object-contain"
          />
        </div>
      )}

      <div className="text-center">
        <h1 className="mx-auto sub-heading">Property View</h1>
        <h1 className="heading">{singlePost?.propertyName}</h1>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <p>Loading...</p>
        </div>
      ) : singlePost ? (
        <div className="flex flex-col md:flex-row gap-4 mt-8">
          <div className="flex-1">
            {singlePost.images && singlePost.images.length > 0 ? (
              <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                {singlePost.images.map((image, index) => (
                  <img
                    key={index}
                    src={urlFor(image).width(300).url()}
                    alt={`${singlePost.propertyName} - ${index + 1}`}
                    className="w-full h-48 object-cover rounded-lg cursor-pointer"
                    onClick={() => setPreviewImage(urlFor(image).url())}
                  />
                ))}
              </div>
            ) : (
              <p>No images available</p>
            )}
          </div>

          <div className="flex-1">
            <div className="flex items-center gap-x-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiMap />
              </div>
              <p className="text-sm font-bold">LOCATION</p> <br />
            </div>
            <p className="text-sm font-bold">{singlePost.location}</p>

            {/* <div className="flex items-center gap-x-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiMap />
              </div>
              <p className="text-sm font-bold">{singlePost.location}</p>
            </div> */}

            <div className="flex items-center gap-x-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiMapAlt />
              </div>
              <p className="text-sm font-bold">PROPERTY TYPE</p> <br />
            </div>
            <p className="text-sm font-bold">
              {singlePost.propertyType?.charAt(0).toUpperCase() + singlePost.propertyType?.slice(1)}
            </p>

            {/* <div className="flex items-center gap-x-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiMapAlt />
              </div>
              <p className="text-sm font-bold">{singlePost.propertyType}</p>
            </div> */}

            <div className="flex items-center gap-x-2 mt-2">
              {/* <BiMap className="icon-box" /> */}
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiFile />
              </div>
              <p className="text-sm font-bold">DESCRIPTION</p>
            </div>
            <p className="text-sm font-bold">{singlePost.description1}</p>

            <div className="flex items-center gap-x-2 mt-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiFile />
              </div>
              <p className="text-sm font-bold">SERVICES</p>
            </div>
            <p className="text-sm font-bold">{singlePost.services1}</p>

            <div className="flex items-center gap-x-2 mt-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiMoney />
              </div>
              <p className="text-sm font-bold">ASKING PRICE: {singlePost.price1}</p>
            </div>

            {/* Conditional rendering for DESCRIPTION2 */}
            {singlePost.description2 && singlePost.description2 !== "0" && (
              <>
                <div className="flex items-center gap-x-2 mt-2">
                  <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                    <BiFile />
                  </div>
                  <p className="text-sm font-bold">DESCRIPTION2</p>
                </div>
                <p className="text-sm font-bold">{singlePost.description2}</p>
              </>
            )}

            {/* Conditional rendering for SPECIAL CONDITION/STATUS */}
            {singlePost.special_condition_status && singlePost.special_condition_status !== "0" && (
              <>
                <div className="flex items-center gap-x-2 mt-2">
                  <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                    <BiFile />
                  </div>
                  <p className="text-sm font-bold">SPECIAL CONDITION/STATUS</p>
                </div>
                <p className="text-sm font-bold">{singlePost.special_condition_status}</p>
              </>
            )}

            {/* Conditional rendering for PRICE2 */}
            {singlePost.price2 && singlePost.price2 !== 0 && singlePost.price2 !== "0" && (
              <div className="flex items-center gap-x-2 mt-2">
              <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                <BiMoney />
              </div>
                <p className="text-sm font-bold">ASKING PRICE2: {singlePost.price2}</p>
              </div>
            )}

            <button
              className="gap-2 mt-4 btn btn-primary flex-center-center"
              onClick={() => window.location.href = 'tel:+260977806600'}
            >
              <BiPhoneCall />
              <span>Call Us Now</span>
            </button>

            <button
              className="gap-2 mt-4 btn btn-primary flex-center-center"
              onClick={() => window.location.href = 'https://wa.me/260977806600'}
            >
              <BiMessageAdd />
              <span>WhatsApp Us</span>
            </button>

            <button
              className="gap-2 mt-4 btn btn-primary flex-center-center" 
              onClick={() => window.location.href = 'mailto:douglas@rockproperties.co.zm'}
              >
                <BiMailSend />
                <span>Email Us Now</span>                 
            </button>

            <button
              className="gap-2 mt-4 btn btn-primary flex-center-center"
              onClick={handleGoBack}
            >
              <BiArrowBack />
              <span>.....Go Back......</span>
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center py-10">
          <p>Property not found.</p>
        </div>
      )}
    </div>
  );
};

export default SinglePost;
